<template>
    <div>
        <b-card bg-variant="light">
            <b-row class="my-3 align-items-center">
                <b-col cols='10'>
                    <b-row class="align-items-center">
                        <b-col cols='3'>
                            <lg-form-input v-model="filtros.numero" label="Número:"></lg-form-input>
                        </b-col>
                        <b-col cols='3'>
                            <lg-form-date description="" v-model="filtros.dataValidade" placeholder="Data de Validade"
                                label="Data de Validade:"></lg-form-date>
                        </b-col>
                        <b-col cols='3'>
                            <LgFinderPagePessoa prefix="Consultar Orçamento > " @change="load"
                                v-model="filtros.responsavel" id="finderPagePessoa" label="Responsável:" cols="12" />
                        </b-col>
                        <b-col cols='3'>
                            <lg-form-const-select label="Situação:" v-model="filtros.situacao"
                                :disabled="situacaoFixa != null" :options="situacoes" @change="load" />
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols='2' class='d-flex justify-content-center align-items-center'>
                    <b-button id="localizar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                        @click="load()">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="search" />
                            <b-tooltip target="localizar" title="Localizar" triggers="hover"></b-tooltip>
                        </div>
                    </b-button>
                    <b-button id="Limpar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                        @click="clearForm">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="eraser" />
                        </div>
                        <b-tooltip target="Limpar" title="Limpar" triggers="hover"></b-tooltip>
                    </b-button>
                    <b-button id="novo" class="mr-2 my-2" size="sm" style="height: 20px" pill
                        @click="openModalCadastroOrcamento" variant="primary">
                        <div class="btn-size-alinhamento">
                            <b-icon scale="1" icon="plus" />
                        </div>
                        <b-tooltip target="novo" title="Adicionar novo..." triggers="hover"></b-tooltip>
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <lg-form-input class="mt-3" v-model="qtdOrcamentoVencidosComplete" disabled label=" "></lg-form-input>
            </b-row>

        </b-card>

        <b-card bg-variant="light">
            <b-table id="my-table" :items="records" :fields="orcamentos" responsive="sm" hover show-empty
                :busy="this.busy" @row-dblclicked="rowSelect">
                <template #empty>
                    <p>Nenhum registro encontrado</p>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template #cell(descricaoStatus)="data">
                    <b-badge :variant="getBadgeVariant(data.item.status)">
                        {{ data.item.descricaoStatus }}
                    </b-badge>
                </template>
                <template #cell(dataValidade)="data">
                    {{ formatDate(data.item.dataValidade) }}
                </template>
                <template #cell(opcoes)="data">
                    <div style="display: inline-block;" v-for="button in getButtons(data.item.status, data.item)"
                        :key="button.id + '-' + data.item.id">
                        <b-button :id="button.id + '-' + data.item.id" size="sm" variant="primary" class="mr-1"
                            @click="button.action" pill>
                            <b-icon :icon="button.icon"></b-icon>
                            <b-tooltip :target="button.id + '-' + data.item.id" :title="button.tooltip"
                                triggers="hover"></b-tooltip>
                        </b-button>
                    </div>
                </template>
            </b-table>

            <b-row style="margin-top: 12px">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                        {{
                            totalPage }} -
                        {{ total }} registros</b-col>
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                            :options="perPageOptions">
                        </b-form-select>
                    </b-col>
                </b-col>
                <b-col cols="6">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                            :total-rows="total"></b-pagination>
                    </div>
                </b-col>
            </b-row>


        </b-card>
        <ConsultarOrcamentoForm v-if="showConsultarOrcamento" :id="selectedOrcamentoId" :readonly="isReadonly"
            @close='fechar' @saved="handleOrcamentoSaved" :prefix='prefix'></ConsultarOrcamentoForm>
        <ModalFinalizarProposta :autorizacaoSelecionada="autorizacaoSelecionada" v-if="showModalFinalizarProposta"
            :orcamentoId="selectedOrcamentoId" @finalizar="finalizarOrcamento" @close="fecharModalFinalizarProposta"
            @notify="handleNotify" :prefix='prefix' />
    </div>
</template>

<script>
import moment from "moment"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConsultarOrcamentoForm from "./ConsultarOrcamentoForm.vue"
import ModalFinalizarProposta from "@/core/components/Modals/ModalFinalizarProposta.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import StatusEnum from "@/core/utils/StatusEnum"
import TipoRequisicaoCompraEnum from "@/core/utils/TipoRequisicaoCompraEnum"
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";

export default {
    components: {
        ConsultarOrcamentoForm,
        ModalFinalizarProposta,
        LgFormDate,
        LgFormInput,
        LgFormConstSelect,
        LgFinderPagePessoa,
    },
    props: {
        autorizacaoSelecionada: {
            type: Object,
            default: null,
        },
        situacaoFixa: {
            type: Number,
            default: null,
        },
        autorizacao: {
            type: Object,
            default: null,
        }
    },
    mixins: [ConfirmMixin, ListResourceMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/orcamentos`)

        this.load()
    },
    data() {
        return {
            qtdOrcamentoVencidosComplete: '',
            qtdOrcamentoVencidosTexto: 'Quantidade de orçamentos vencidos: ',

            filtros: {
                numero: '',
                dataValidade: null,
                responsavel: '',
                situacao: this.situacaoFixa
            },
            situacoes: [
                { value: null, text: 'Todas' },
                { value: StatusEnum.ORCAMENTO_EM_ANDAMENTO.value, text: StatusEnum.ORCAMENTO_EM_ANDAMENTO.descricao },
                { value: StatusEnum.ORCAMENTO_APROVADO.value, text: StatusEnum.ORCAMENTO_APROVADO.descricao },
                { value: StatusEnum.ORCAMENTO_FINALIZADO.value, text: StatusEnum.ORCAMENTO_FINALIZADO.descricao },
                { value: StatusEnum.ORCAMENTO_VENCIDO.value, text: StatusEnum.ORCAMENTO_VENCIDO.descricao }
            ],
            showConsultarOrcamento: false,
            showModalCadastroOrcamento: false,
            orcamentos: [
                { key: 'numero', label: 'Número' },
                { key: 'dataValidade', label: 'Data de Validade' },
                { key: 'responsavelNome', label: 'Responsável' },
                { key: 'descricaoStatus', label: 'Status' },
                { key: 'opcoes', label: '', class: 'text-center' }
            ],
            perPageOptions: [5, 10, 15, 20],
            selectedOrcamentoId: null,
            isReadonly: false,
            showModalFinalizarProposta: false,
            selectedItem: null,
            prefix: ['Consultar Orçamento'],
        }
    },
    watch: {
        page() {
            this.load()
        },
    },
    methods: {
        async tabelaOrcamentaria(orcamento) {

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-tabela-orcamentaria')
                const { data } = await resource.get(`${orcamento}`);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo)
            } finally {
                this.busy = false
            }
        },
        async finalizarOrcamento() {
            this.busy = true;

            if (this.autorizacaoSelecionada == null) {
                this.busy = false;
                this.$notify({
                    message: 'O orçamento foi finalizado com sucesso',
                    type: 'success',
                    title: 'Sucesso',
                });
                this.fecharModalFinalizarProposta();

            } else {

                var { data } = await this.$service.findById(this.selectedOrcamentoId);

                if (data.status.id == StatusEnum.ORCAMENTO_FINALIZADO.value) {

                    this.$notify({
                        message: 'O orçamento foi associado a autorização com sucesso',
                        type: 'success',
                        title: 'Sucesso',
                    });
                    this.$emit("rowSelect");


                } else {
                    this.busy = false;
                    this.$notify({
                        message: 'O orçamento para compra direta precisa ter ao menos uma proposta aceita por item',
                        type: 'danger',
                        title: 'Erro',
                    });
                }
            }
        },
        async rowSelect(item) {
            if (this.autorizacaoSelecionada != null) {
                if (this.autorizacaoSelecionada.tipoCompra == TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod) {

                    this.abrirModalFinalizarProposta(item);
                }
                else {

                    await this.$service.put(`${item.id}/finalizarOrcamento`, { autorizacao: this.autorizacaoSelecionada.id, statusId: StatusEnum.ORCAMENTO_FINALIZADO.value })
                    this.$notify({
                        message: 'Orçamento foi associado a requisição',
                        type: 'success',
                        title: 'Sucesso',
                    });
                    this.$emit("rowSelect", item)


                }
            } else
                this.$emit("rowSelect", item)
        },

        fechar() {
            this.showModalCadastroOrcamento = false
            this.showConsultarOrcamento = false
            this.showModalFinalizarProposta = false
            this.selectedOrcamentoId = null
            this.isReadonly = false
            this.load()
        },
        openModalCadastroOrcamento() {
            this.selectedOrcamentoId = null
            this.isReadonly = false
            this.showConsultarOrcamento = true
        },
        openConsultarOrcamento(id) {
            this.selectedOrcamentoId = id
            this.isReadonly = false
            this.showConsultarOrcamento = true
        },
        visualizarOrcamento(id) {
            this.selectedOrcamentoId = id
            this.isReadonly = true
            this.showConsultarOrcamento = true
        },
        async load() {
            this.busy = true
            this.filtro = {};

            if (this.filtros.responsavel && this.filtros.responsavel.id)
                this.filtro.responsavel = this.filtros.responsavel.id;

            if (this.filtros.numero)
                this.filtro.numero = this.filtros.numero;

            if (this.filtros.dataValidade)
                this.filtro.dataValidade = moment(String(this.filtros.dataValidade)).format(
                    "DD/MM/YYYY"
                );

            if (this.filtros.situacao)
                this.filtro.situacao = this.filtros.situacao;


            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

            var { data } = await this.$service.get('quantidade-vencidas')

            this.qtdOrcamentoVencidosComplete = this.qtdOrcamentoVencidosTexto + data;


        },
        getBadgeVariant(status) {
            switch (status) {
                case StatusEnum.ORCAMENTO_EM_ANDAMENTO.value:
                    return 'primary'
                case StatusEnum.ORCAMENTO_APROVADO.value:
                    return 'success'
                default:
                    return 'secondary'
            }
        },
        clearForm() {
            this.filtros = {
                numero: '',
                dataValidade: null,
                responsavel: '',
                situacao: this.situacaoFixa != null ? this.situacaoFixa : null
            }
            this.load()
        },
        getButtons(status, item) {

            switch (status) {
                case StatusEnum.ORCAMENTO_EM_ANDAMENTO.value:
                    return [
                        { id: 'tabela', variant: 'primary', icon: 'table', tooltip: 'Tabela Orçamentária', action: () => this.tabelaOrcamentaria(item.id) },

                        { id: 'finalizar', variant: 'primary', icon: 'check-circle', tooltip: 'Finalizar Proposta', action: () => this.abrirModalFinalizarProposta(item) },
                        { id: 'editar', variant: 'primary', icon: 'pencil-square', tooltip: 'Editar Orçamento', action: () => this.openConsultarOrcamento(item.id) },
                        { id: 'visualizar', variant: 'primary', icon: 'eye', tooltip: 'Visualizar', action: () => this.visualizarOrcamento(item.id) }
                    ];


                case StatusEnum.ORCAMENTO_EM_APROVACAO.value:
                    return [
                        { id: 'tabela', variant: 'primary', icon: 'table', tooltip: 'Tabela Orçamentária', action: () => this.tabelaOrcamentaria(item.id) },

                        { id: 'finalizar', variant: 'primary', icon: 'check-circle', tooltip: 'Finalizar Proposta', action: () => this.abrirModalFinalizarProposta(item) },
                        { id: 'editar', variant: 'primary', icon: 'pencil-square', tooltip: 'Editar Orçamento', action: () => this.openConsultarOrcamento(item.id) },
                        { id: 'visualizar', variant: 'primary', icon: 'eye', tooltip: 'Visualizar', action: () => this.visualizarOrcamento(item.id) }
                    ]

                case StatusEnum.ORCAMENTO_APROVADO.value:
                    return [
                        { id: 'tabela', variant: 'primary', icon: 'table', tooltip: 'Tabela Orçamentária', action: () => this.tabelaOrcamentaria(item.id) },
                        { id: 'visualizar', variant: 'primary', icon: 'eye', tooltip: 'Visualizar', action: () => this.visualizarOrcamento(item.id) }

                    ]

                case StatusEnum.ORCAMENTO_FINALIZADO.value:
                    return [
                        { id: 'tabela', variant: 'primary', icon: 'table', tooltip: 'Tabela Orçamentária', action: () => this.tabelaOrcamentaria(item.id) },

                        { id: 'visualizar', variant: 'primary', icon: 'eye', tooltip: 'Visualizar', action: () => this.visualizarOrcamento(item.id) }

                    ]
            }
        },
        abrirModalFinalizarProposta(item) {
            this.selectedOrcamentoId = item.id
            this.showModalFinalizarProposta = true
        },
        fecharModalFinalizarProposta() {
            this.showModalFinalizarProposta = false
            this.selectedItem = null
            this.load()
        },
        handleNotify(message) {
            this.showModalFinalizarProposta = false
            this.selectedItem = null
            this.$bvToast.toast(message, {
                title: 'Erro',
                variant: 'danger',
                solid: true
            })
        },
        formatDate(date) {
            if (!date) return ''
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        handleOrcamentoSaved() {
            this.$bvToast.toast('Orçamento salvo com sucesso.', {
                title: 'Sucesso',
                variant: 'success',
                solid: true
            })
            this.fechar()
        }
    }
}
</script>

<style scoped>
.text-right {
    text-align: right;
}
</style>